var origin = window.location.origin
// var dev = origin === 'http://localhost:3000'
// var apiRoot = dev ? 'http://localhost:8080' : origin
var apiRoot = 'http://localhost:8080'

var                                                                                                                                           appConfig = {
  clientId: 'xyza7891oJUhBrmdLuE9lL9tc2Wg9EKE', // for interacting with the client Login service
  nhsRootDomain: 'https://www.epicgames.com/id',
  product_Id:'6764477a808a43739941625310463ff8',
  responseType: 'code',
  scope: 'basic_profile%20email',
  redirectUri: origin + '/callback',
  apiTokenEndpoint: apiRoot + '/api/token',
  apiRefreshEndpoint: apiRoot + '/api/refresh',
  apiUserinfoEndpoint: apiRoot + '/api/user-info',
}

export default appConfig
